module.exports = __webpack_public_path__ + "img/dzwj.d20dbea4.png";